import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";

const pathMap = {
	[Locale.cs]: "proces" as const,
} satisfies LocalizedString;

export function getWorkingProcessAnchor(tenant: Tenant): string {
	return pathMap[tenant.locale];
}
